export default {
  title: 'יצירת עמלות סוכנות',
  side: {
    tabs: 'מידע נוסף',
    comments: 'הערות',
    actions: 'פעולות',
  },
  form: {
    company: 'חברה מנהלת',
    product: 'מוצר',
    agencyFeeMonthlyDeposit: 'עמלת סוכנות נפרעים מהפקדה %',
    agencyFeeMonthlyAccumulation: 'עמלת סוכנות נפרעים מצבירה %',
    agencyFeeAnnualAccumulation: 'עמלת סוכנות היקף מצבירה %',
    agencyFeeAnnualDeposit: 'עמלת סוכנות היקף מהפקדה %',
    agentNumber: 'מספר סוכן',
    payeeFeesStartDate: 'החל מתאריך לעמלות נפרעים',
    payeeFeesValidityDate: 'תאריך תוקף לעמלות נפרעים',
    isPayeeFeesVatIncluded: 'האם העמלות כוללות מע״מ?',
    volumeFeesStartDate: 'החל מתאריך לעמלות היקף',
    volumeFeesValidityDate: 'תאריך תוקף לעמלות היקף',
    isVolumeFeesVatIncluded: 'האם העמלות כוללות מע״מ?',
    uploadFiles: 'העלאת קבצים',
    comments: 'הערות',
  },
  notification: {
    success: {
      title: 'עמלת הסוכנות נוספה בהצלחה',
      message: 'פרטי עמלות הסוכנות נוספו במערכת',
    },
    failure: {
      title: 'הפרטים לא נוספו',
      message: 'אירעה שגיאה בניסיון העדכון',
    },
    validtion: {
      title: 'הפרטים לא נוספו',
      message: 'אחד מהפרטים שהוזנו איזו תקין',
    },
  },
};
